export default "__VITE_ASSET__DlZEGmGJ__"